import { LmIconFilledBusinessPieChart, LmIconOutlineBusinessPieChart } from '@mes-ui/lemma/icons';

import { WidgetIconProps } from '../types';

const IconProfessionProforientationCommon = ({ iconType, ...rest }: WidgetIconProps) =>
  iconType === 'outlined' ? <LmIconOutlineBusinessPieChart {...rest} /> : <LmIconFilledBusinessPieChart {...rest} />;

export default IconProfessionProforientationCommon;
